import { render, staticRenderFns } from "./liveCommentArea.vue?vue&type=template&id=24b1ad8d&"
import script from "./liveCommentArea.vue?vue&type=script&lang=js&"
export * from "./liveCommentArea.vue?vue&type=script&lang=js&"
import style0 from "./liveCommentArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports